import { Box, FormGroup, Select, TextInput } from '@ksyos/design-system';
import type { ValidationErrors } from '@frontend/utils';
import { getSelectedLanguage } from '@frontend/translate';
import { getValidationErrorTranslation } from '@frontend/utils';
import { PaymentsSearchField } from '../paymentsSearchField';

interface IPaymentsSearchForFilterProps {
    errors: ValidationErrors;
    onChangeSearchField: (value: PaymentsSearchField | undefined) => void;
    onChangeSearchText: (value: string | undefined) => void;
    onValidateOne: (value: string | undefined) => void;
    searchField?: PaymentsSearchField;
    searchText?: string;
}

export function PaymentsSearchForFilter(props: IPaymentsSearchForFilterProps) {
    const language = getSelectedLanguage();
    const { searchField, searchText, errors, onChangeSearchText, onValidateOne, onChangeSearchField } = props;

    return (
        <FormGroup
            hasErrors={errors.has('searchText')}
            label={language.common.searchFor}
            tooltipText={language.finance.searchForTooltip}
        >
            <Box sx={{ display: 'flex' }}>
                <Box
                    marginRight={2}
                    width={'55%'}
                >
                    <TextInput
                        error={getValidationErrorTranslation(errors.get('searchText'))}
                        id="search"
                        onChange={(event) => {
                            onChangeSearchText(event.target.value || undefined);
                            onValidateOne(event.target.value || undefined);
                        }}
                        onReset={() => onChangeSearchText(undefined)}
                        placeholder={language.common.searchTerm}
                        value={searchText ?? ''}
                    />
                </Box>
                <Box width={'45%'}>
                    <Select
                        isClearable={true}
                        onChange={(item) => onChangeSearchField(item?.value)}
                        options={Object.values(PaymentsSearchField).map((field) => {
                            return { label: language.processSearchField[field], value: field };
                        })}
                        placeholder={language.common.searchIn}
                        value={
                            searchField && {
                                label: language.processSearchField[searchField],
                                value: searchField,
                            }
                        }
                    />
                </Box>
            </Box>
        </FormGroup>
    );
}
